// @flow
import styled from 'styled-components';
import { PAPER_WHITE_COLOR } from '../config/constants';

const SYTag11ptExtended = styled.p`
  font-family: Poppins, sans-serif;
  font-size: 11px;
  line-height: 1.36;
  letter-spacing: 1px;
  color: ${PAPER_WHITE_COLOR};
`;

export default SYTag11ptExtended;
